import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "and",
  "use": "and-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol viewBox=\"0 0 13 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"and\"><path d=\"M42.114,42.816 L38.82,42.816 L37.632,41.556 C36.696,42.456 35.472,43.032 34.086,43.032 C32.016,43.032 30,41.718 30,39.252 C30,37.524 31.044,36.462 32.16,35.724 C31.548,34.95 31.08,34.158 31.08,33.114 C31.08,31.17 32.664,30 34.608,30 C36.696,30 37.992,31.35 37.992,33.024 C37.992,34.356 37.164,35.4 35.796,36.156 L37.398,37.812 C37.668,37.182 37.884,36.57 38.118,35.814 L40.656,35.814 C40.278,37.146 39.702,38.496 39.108,39.63 L42.114,42.816 Z M36.048,39.882 L33.69,37.38 C33.06,37.812 32.502,38.424 32.502,39.27 C32.502,40.35 33.384,40.8 34.158,40.8 C34.806,40.8 35.544,40.512 36.048,39.882 Z M34.302,34.554 C35.094,34.104 35.508,33.582 35.508,33.078 C35.508,32.592 35.148,32.214 34.572,32.214 C34.014,32.214 33.582,32.574 33.582,33.114 C33.582,33.6 33.924,34.068 34.302,34.554 Z\" transform=\"translate(-30 -30)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/and.svg
// module id = 1724
// module chunks = 0